import axios from "axios";
import { BaseApiUrl } from "./base";
import { getSemesterList } from './modules/misc';

const base = BaseApiUrl;

/** 部门树节点组织类型（小写） */
export function homeVisitDeptOrgType(dataOrNode) {
  const data = dataOrNode && dataOrNode.data ? dataOrNode.data : dataOrNode;
  if (!data) return "";
  return String(data.DeptOrgType != null ? data.DeptOrgType : data.deptOrgType || "").toLowerCase();
}

/** 是否学校根节点 */
export function isHomeVisitSchoolDeptNode(dataOrNode) {
  const t = homeVisitDeptOrgType(dataOrNode);
  return t === "school" || t === "affiliateschool";
}

/** 是否行政班节点 */
export function isHomeVisitClassDeptNode(node) {
  return homeVisitDeptOrgType(node) === "class";
}

/** 是否为学校以下的收窄范围（校区/学部/年级/班级等） */
export function isHomeVisitNarrowScopeNode(node) {
  if (!node || !node.data) return false;
  return !isHomeVisitSchoolDeptNode(node);
}

/** 从部门树节点解析学校根 Id */
export function resolveHomeVisitSchoolIdFromTreeNode(node, fallbackId) {
  const isSchoolType = (type) => {
    const t = String(type || "").toLowerCase();
    return t === "school" || t === "affiliateschool";
  };
  if (node && node.data) {
    const selfType = node.data.DeptOrgType != null ? node.data.DeptOrgType : node.data.deptOrgType;
    if (isSchoolType(selfType)) {
      return Number(node.data.value);
    }
  }
  let n = node && node.parent;
  while (n && n.data) {
    const t = n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType;
    if (isSchoolType(t)) {
      return Number(n.data.value);
    }
    n = n.parent;
  }
  return fallbackId ? Number(fallbackId) : 0;
}

/** 切换学校时重置列表 */
export function onHomeVisitSchoolChange(vm, departmentId) {
  vm.DepartmentId = departmentId;
  vm.schoolId = 0;
  vm.classDepartmentId = 0;
  if (vm.semesterList) vm.semesterList = [];
  if (vm.selectedSemesterId != null) vm.selectedSemesterId = null;
  if (vm.filterSemesterId != null) vm.filterSemesterId = null;
  if (vm.listKeyword != null) vm.listKeyword = "";
  if (vm.users) vm.users = [];
  if (vm.rows) vm.rows = [];
  if (vm.total != null) vm.total = 0;
  if (vm.page != null) vm.page = 1;
  if (vm.questionnaire) vm.questionnaire = null;
  if (vm.questionnaireList) vm.questionnaireList = [];
  if (vm.statistics) vm.statistics = null;
}

/** 学期选项 Id */
export function homeVisitSemesterId(s) {
  return s ? (s.Id != null ? s.Id : s.id) : null;
}

/** 学期选项名称 */
export function homeVisitSemesterName(s) {
  return s ? (s.SemesterName || s.semesterName || "") : "";
}

/** 加载学期下拉 */
export async function loadHomeVisitSemesterList(vm, schoolDepartmentId) {
  if (!schoolDepartmentId) {
    vm.semesterList = [];
    vm.selectedSemesterId = null;
    if (vm.filterSemesterId != null) vm.filterSemesterId = null;
    return [];
  }
  const res = await getSemesterList({ departmentId: schoolDepartmentId });
  const list = res && res.success ? (res.response || []) : [];
  vm.semesterList = list;
  // 记录/统计页：默认选中当前学期
  if (!vm.selectedSemesterId && list.length) {
    const current = list.find((s) => s.IsCurrent === 1 || s.isCurrent === 1);
    vm.selectedSemesterId = current ? homeVisitSemesterId(current) : homeVisitSemesterId(list[0]);
  }
  // 问卷列表页：校验已选学期是否仍属于当前学校
  if (vm.filterSemesterId != null) {
    const exists = list.some((s) => homeVisitSemesterId(s) === vm.filterSemesterId);
    if (!exists) vm.filterSemesterId = null;
  }
  return list;
}

export const getHomeVisitQuestionnaireList = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetQuestionnaireList`, { params });
};

export const getHomeVisitQuestionnaireDetail = (questionnaireId) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetQuestionnaireDetail`, { params: { questionnaireId } });
};

export const saveHomeVisitQuestionnaire = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/SaveQuestionnaire`, data);
};

export const initHomeVisitDefaultQuestions = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/InitDefaultQuestions`, data);
};

export const getHomeVisitQuestionBank = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetQuestionBank`, { params });
};

export const getHomeVisitQuestionBankAll = (schoolDepartmentId) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetQuestionBankAll`, { params: { schoolDepartmentId } });
};

export const importHomeVisitQuestionBank = (formData, schoolDepartmentId) => {
  return axios.post(
    `${base}/api/HomeVisitAdmin/ImportQuestionBank?schoolDepartmentId=${schoolDepartmentId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

export const initHomeVisitQuestionBank = (schoolDepartmentId) => {
  return axios.post(`${base}/api/HomeVisitAdmin/InitQuestionBank?schoolDepartmentId=${schoolDepartmentId}`);
};

export const createHomeVisitQuestionnaireFromBank = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/CreateQuestionnaireFromBank`, data);
};

export const saveHomeVisitQuestionBankItem = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/SaveQuestionBankItem`, data);
};

export const deleteHomeVisitQuestionBankItem = (schoolDepartmentId, questionId) => {
  return axios.delete(`${base}/api/HomeVisitAdmin/DeleteQuestionBankItem`, {
    params: { schoolDepartmentId, questionId }
  });
};

export const setHomeVisitQuestionBankItemDefault = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/SetQuestionBankItemDefault`, data);
};

/** 是否题库默认勾选 */
export function isHomeVisitBankDefault(question) {
  if (!question) return false;
  if (question.IsBankDefault != null) return !!question.IsBankDefault;
  if (question.isBankDefault != null) return !!question.isBankDefault;
  return true;
}

export const setHomeVisitQuestionnaireDefault = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/SetQuestionnaireDefault`, data);
};

export const deleteHomeVisitQuestionnaire = (questionnaireId) => {
  return axios.delete(`${base}/api/HomeVisitAdmin/DeleteQuestionnaire`, { params: { questionnaireId } });
};

export const deleteHomeVisitQuestionnaireQuestion = (questionnaireId, questionId) => {
  return axios.delete(`${base}/api/HomeVisitAdmin/DeleteQuestionnaireQuestion`, {
    params: { questionnaireId, questionId }
  });
};

export const saveHomeVisitQuestionnaireQuestion = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/SaveQuestionnaireQuestion`, data);
};

export const importHomeVisitQuestions = (formData, questionnaireId) => {
  return axios.post(
    `${base}/api/HomeVisitAdmin/ImportQuestions?questionnaireId=${questionnaireId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

export const downloadHomeVisitImportTemplate = () => {
  return axios.get(`${base}/api/HomeVisitAdmin/DownloadImportTemplate`, { responseType: "blob" });
};

export const getHomeVisitRecordPage = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetRecordPage`, { params });
};

export const getHomeVisitStatistics = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetStatistics`, { params });
};

export const getHomeVisitTeacherVisitDetail = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetTeacherVisitDetail`, { params });
};

export const getHomeVisitClassStudentProgress = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetClassStudentProgress`, { params });
};

export const exportHomeVisitSummary = (params) => {
  return axios.get(`${base}/api/HomeVisitAdmin/ExportSummary`, { params, responseType: "blob" });
};

export const deleteHomeVisitRecord = (recordId) => {
  return axios.delete(`${base}/api/HomeVisitAdmin/DeleteRecord`, { params: { recordId } });
};

/** 获取家访学校配置 */
export const getHomeVisitConfig = (schoolId) => {
  return axios.get(`${base}/api/HomeVisitAdmin/GetConfig`, { params: { schoolId } });
};

/** 保存家访学校配置 */
export const saveHomeVisitConfig = (data) => {
  return axios.post(`${base}/api/HomeVisitAdmin/SaveConfig`, data);
};

/** 下载 blob 为 Excel */
export function downloadBlobExcel(res, filePrefix) {
  const blob = new Blob([res.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filePrefix + "_" + new Date().getTime() + ".xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
}

export function visitTypeText(type) {
  return type === 2 ? "回访" : "首次家访";
}

/** 题目选项列表（兼容 PascalCase / camelCase） */
export function homeVisitQuestionOptions(question) {
  if (!question) return [];
  return question.Options || question.options || [];
}
